import { ReactiveFormsModule } from "@angular/forms";
import { MatSelectModule } from "@angular/material/select";
import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { take, takeUntil } from "rxjs/operators";
import { FormControl } from "@angular/forms";
import { ReplaySubject, Subject } from "rxjs";
import { MatSelect } from "@angular/material/select";
import { ErfassungswellenService } from "@core/erfassungswellen/erfassungswellen.service";
import { MatInputModule } from "@angular/material/input";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { CommonModule } from "@angular/common";
import { Erfassungswelle } from "@core/erfassungswellen/erfassungswelle.model";
import { FlexLayoutModule } from "@ngbracket/ngx-layout";
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@Component({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatAutocompleteModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    FlexLayoutModule,
  ],
  standalone: true,
  selector: "app-filterable-select",
  templateUrl: "./filterable-select.component.html",
  styleUrls: ["./filterable-select.component.scss"],
})
export class FilterableSelectComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  public _data: any;
  private currentErfassungswelle: Erfassungswelle | null = null;

  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();

  /** control for the selected bank */
  public bankCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword */
  public bankFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredBanks: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  @ViewChild("singleSelect", { static: true }) singleSelect!: MatSelect;

  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  constructor(private erfassungswelleService: ErfassungswellenService) {}

  ngOnInit() {
    this.currentErfassungswelle =
      this.erfassungswelleService.getCurrentErfassungswelle(); // load initial value
    this.erfassungswelleService
      .getCurrentErfassungswelleSubject()
      .subscribe((result) => {
        // subscribe to updates
        this.currentErfassungswelle = result;
        this.inputDataChanged();
      });

    this.loadAllErfassungswelle();
  }

  loadAllErfassungswelle() {
    this.erfassungswelleService.getUnfilteredAllErfassungswellen().subscribe(
      (response) => {
        this._data = response.body;
        this.inputDataChanged();
      },
      (error) => {
        console.error("Error loading erfassungswellen");
      }
    );
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  inputDataChanged() {
    // set initial selection
    this.bankCtrl.setValue(this._data);

    // load the initial bank list
    this.filteredBanks.next(this._data);
    // listen for search field value changes
    this.bankCtrl.setValue(this.currentErfassungswelle);
    this.bankFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });
  }

  /**
   * Sets the initial value after the filteredBanks are loaded initially
   */
  protected setInitialValue() {
    this.filteredBanks
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.singleSelect.compareWith = (a: any, b: any) =>
          a && b && a.id === b.id;
      });
  }

  protected filterBanks() {
    if (!this._data) {
      return;
    }
    // get the search keyword
    let search = this.bankFilterCtrl.value;
    if (!search) {
      this.filteredBanks.next(this._data.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredBanks.next(
      this._data.filter(
        (bank: any) => bank.name.toLowerCase().indexOf(search) > -1
      )
    );
  }

  selectionChanged() {
    this.dataChange.emit(this.bankCtrl.value);
    this.erfassungswelleService.setCurrentErfassungswelle(this.bankCtrl.value);
  }

  checkNewErfassungswellen() {
    this.loadAllErfassungswelle();
  }
}
